<template>
  <div class="card">
    <div @click.stop>
      <div class="dentation"></div>
      <van-row class="fvlr cardBox">
        <van-col span="6">
          <div class="rightsTypeWrap">
            <div class="rightsTypeBox rightsTypeItem">
              - - <span>{{ datas.typeName }}</span> - -
            </div>
            <p class="rightsTypeItem rightsCore" :class="{ disable }">
              {{ datas.discountStr }}
            </p>
            <p class="rightsTypeItem">{{ datas.thresholdStr }}</p>
          </div>
        </van-col>
        <van-col span="1">
          <div class=" dashedBox">
            <div class="dashedLine"></div>
          </div>
        </van-col>
        <van-col span="15">
          <div class=" rightsInfoBox fhl">
            <p class="rightsName ellipsis">
              {{ datas.rightName ? datas.rightName : '暂无名称' }}
              <!-- --{{ datas._flag }}--.{{ datas._type }} -->
            </p>
            <p class="rightsRule" v-if="datas.activeTypeFlag == 1">有效期：{{ datas.activeStartTime }}-{{ datas.activeEndTime }}</p>
            <p class="rightsRule" v-else>有效期：{{ datas.activeMonth == -1 ? '无限制' : `${datas.activeMonth || ''}个月` }}</p>
          </div>
        </van-col>
        <van-col span="2">
          <van-checkbox checked-color="#3088c5" :name="datas._flag" shape="square" :ref="el => (checkboxRefs[index] = el)" />
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed } from 'vue'
export default {
  props: {
    datas: {
      type: Object,
      default: () => {}
    },
    disable: {
      type: Boolean,
      default: false
    },
    isDetail: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    checkboxRefs: {
      type: Array,
      default: () => []
    }
  },
  emits: ['click'],
  setup(props) {
    let { datas, disable, isDetail, index, checkboxRefs } = toRefs(props)
    const state = reactive({
      datas,
      disable,
      isDetail,
      index,
      checkboxRefs
    })
    const selectCoupon = computed(() => state.datas.selectCoupon || '')

    return {
      ...toRefs(state),
      selectCoupon
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  position: relative;
  padding: 12px 0;
  background: #ffffff;
  font-size: 12px;
  // .cardBox {
  :deep(.van-checkbox__icon) {
    font-size: 14px;
  }
  :deep(.van-checkbox) {
    padding-left: 5px !important;
    vertical-align: middle;
  }
  // }
}

// 边缘锯齿
.dentation {
  position: absolute;
  width: 5px;
  height: 60px;
  top: 0;
  left: -4px;
  background-image: url(../../assets/images/dentation.png);
}
// 左侧类型
.rightsTypeWrap {
  color: #666;
  text-align: center;
  .rightsTypeItem {
    color: #999;
  }
  .rightsTypeBox {
    margin-bottom: 4px;
    padding: 0 6px;
    span {
      line-height: 12px;
      vertical-align: middle;
    }
  }
  .rightsCore {
    height: 16px;
    margin-bottom: 4px;
    color: #3088c5;
    font-size: 16px;
    font-weight: 700;
    line-height: 16px;
  }
  .disable {
    color: #999;
  }
}

// 分隔虚线
.dashedBox {
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.dashedLine {
  width: 1px;
  height: 40px;
  border-right: 1px dashed #ccc;
}

// 右侧信息
.rightsInfoBox {
  height: 40px;
  padding-left: 8px;
  color: #999;
  text-align: left;
  .rightsName {
    max-width: 100%;
    padding-top: 2px;
    color: #333;
    font-size: 14px;
    font-weight: bold;
  }
  .rightsRule {
    color: #666;
  }
}
.btnBox {
  width: 104px;
}
</style>
